import waveBlue from '../../../assets/quick-richuels-waves/wave-blue.jpg';
import waveCyan from '../../../assets/quick-richuels-waves/wave-cyan.jpg';
import waveGray from '../../../assets/quick-richuels-waves/wave-gray.jpg';
import waveGreen from '../../../assets/quick-richuels-waves/wave-green.jpg';
import waveOrange from '../../../assets/quick-richuels-waves/wave-orange.jpg';
import wavePink from '../../../assets/quick-richuels-waves/wave-pink.jpg';
import wavePurple from '../../../assets/quick-richuels-waves/wave-purple.jpg';

const CARD_WAVES = [
  waveGreen,
  waveBlue,
  waveCyan,
  wavePurple,
  waveOrange,
  wavePink,
  waveGray,
];

export function cardWaveForIndex(index) {
  const i = Number(index);
  const safe = Number.isFinite(i) && i >= 0 ? Math.floor(i) : 0;
  return CARD_WAVES[safe % CARD_WAVES.length];
}
